module.exports = __webpack_public_path__ + "static/media/banner.51459a83.jpg";